import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { EquipmentComponent } from './equipment.component';
import { EquipmentDetailComponent } from './detail/equipmentdetail.component';

const routes: Routes = [
  {
    path: '',
    component: EquipmentComponent,
  },
  {
    path: ':id',
    component: EquipmentDetailComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EquipmentRoutingModule {}
